<script>
import algoliasearch from 'algoliasearch/lite';
import _get from 'lodash-es/get';

const autocomplete = require('autocomplete.js');

    export default {
        props: {
            appId: {
                required: true,
                type: String,
            },
            searchKey: {
                required: true,
                type: String,
            },
            indexes: {
                required: true,
                type: Array,
            },
        },
        data() {
            return {
                searchClient: null,
                autocomplete: null,
                useHeaders: true,
                displayKey: 'title',
                debug: process.env.NODE_ENV !== 'production',
            };
        },
        created() {
            if (this.appId && this.searchKey) {
                this.searchClient = algoliasearch(
                    this.appId,
                    this.searchKey,
                );
            }
        },
        mounted() {
            EventBus.$on('global-search-closed', () => {
                this.autocomplete ? this.autocomplete.autocomplete.setVal('') : null;
            });
        },
        methods: {
            setup() {
                if (! this.searchClient) {
                    return;
                }

                const options = {
                    debug: this.debug,
                };

                this.autocomplete = autocomplete(this.$refs.input, options,
                    this.indexes.map((index) => {
                        const algoliaIndex = this.searchClient.initIndex(index.name);
                        return {
                            source: autocomplete.sources.hits(algoliaIndex, { hitsPerPage: 5, filters: 'visible=1' }),
                            templates: {
                                header: this.useHeaders ? '<div class="aa-suggestions-category">' + index.label + '</div>' : null,
                                suggestion: (suggestion) => {
                                    const value = this.getValueFromSuggestion(suggestion);
                                    return '<span>' +
                                        value + '</span>';
                                },
                                empty: '<div class="text-sm text-neutral-medium">' + lang(
                                    'Inget resultat hittades',
                                    'Nothing matches your search'
                                ) + '</div>',
                            },
                        };
                    }),
                ).on('autocomplete:selected', function (event, suggestion, dataset, context) {
                    window.location = window.locale === 'sv' ? suggestion.url : `/${window.locale}${suggestion.url}`;
                });
            },
            getValueFromSuggestion(suggestion) {
                let value;
                const object = suggestion._highlightResult;

                const paths = [
                    `${this.displayKey}.${window.locale}.value`,
                    `${this.displayKey}.sv.value`,
                    `${this.displayKey}.value`,
                    'name.sv.value',
                ];

                paths.forEach(path => {
                    const temp = _get(object, path);

                    if (temp && ! value) {
                        value = temp;
                    }
                });

                return autocomplete.escapeHighlightedString(value);
            },
        },
    };
</script>
